import { createSlice } from '@reduxjs/toolkit';
import { User } from '../models/AdministrativeModels';

const initialUser = User.fromJSON({});
const initialAuthToken = localStorage.getItem('auth_token');

const createEmptyAuthState = () => ({
	authToken: null,
	user: User.fromJSON({}),
	isAuthorized: false,
	isActive: false,
	isImpersonating: false
});

const initialState = {
	authToken: initialAuthToken,
	user: initialUser,
	isAuthorized: !!initialAuthToken,
	isActive: !!initialUser?.isActive,
	isImpersonating: false
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthState: (_state, action) => ({
			..._state,
			...action.payload
		}),
		clearAuthState: createEmptyAuthState
	}
});

export const { setAuthState, clearAuthState } = authSlice.actions;

export const selectAuthUser = (state) => state?.auth?.user || {};

export default authSlice.reducer;
